import { initializeApp, getApps, getApp } from "firebase/app";
import { getFunctions } from "firebase/functions";

/**
 * Firebase configuration object.
 * These values should ideally be managed via environment variables for security.
 */
const firebaseConfig = {
  apiKey: "AIzaSyD1H4S-Fs2HrijV-GvJYX3OE1ihzlLuUrM",
  authDomain: "zodiagev7.firebaseapp.com",
  projectId: "zodiagev7",
  storageBucket: "zodiagev7.firebasestorage.app",
  messagingSenderId: "602820086007",
  appId: "1:602820086007:web:5a1a55621f284e6beeebf2"
};

// Initialize Firebase App (Singleton pattern)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
export const functions = getFunctions(app);

export default app;
